export function  langConvImpl (store, val) {


                var translation = val;


                if (store.state.langtranslationfile)   {
  
                    let translationfile = store.state.langtranslationfile;
             
                    try {
                    let pos = (translationfile.findIndex(row => String(row.English).toLowerCase() == val.toLowerCase())); 

                    let translationline =  translationfile.slice(pos, pos+1);

                    //is there a translation then set
                    if (translationline.length == 1) {translation = translationline[0].other}

                    //if just a . then the foreign lanaguage is the same as the english
                    if (translation == '.') {translation = val}
                    
                    } catch {
                        return translation
                    }

                }

                return translation
                
}
export function siteNameImpl (store, val) {
                               
                    let sitename = store.state.sitename ;
                    let shortsitename = 'OddsGalore'
                
                    if (sitename == 'search4bets')  {shortsitename = 'S4B'} 
                
                
                    val = val.replace("[sitename]", shortsitename)
                    return val;
              
}
export function uniqueImpl (arr, key, wherefield1, whereval1, wherefield2, whereval2) {

    var output = []
    var usedKeys = {}
    var addval = true
    
    try {


                    //is array empty or null
                    if (arr === undefined || arr.length == 0) { return output; }

                         
                            for (var i = 0; i < arr.length; i++) {
                                if (!usedKeys[arr[i][key]]) {

                                    //is there a where field and value
                                    if (wherefield1 !== null && whereval1 !== null && typeof wherefield1 !== 'undefined' && typeof whereval1 !== 'undefined') {
                                        if (arr[i][wherefield1] == whereval1) {
                                            //is there a second where field and value
                                            if (wherefield2 !== null && whereval2 !== null && typeof wherefield2 !== 'undefined' && typeof whereval2 !== 'undefined') {
                                                if (arr[i][wherefield2] == whereval2) {
                                                    addval = true;
                                                } else { addval = false }
                                            } else { addval = true }
                                            addval = true;
                                        } else { addval = false }
                                    }

                                    if (addval == true) {
                                        usedKeys[arr[i][key]] = true
                                        output.push(arr[i])
                                    }

                                    addval = true;
                                }
                            }

                            return output
                        }

    catch (err) {

        return output
    }
}
          
        
